/* eslint-disable react-refresh/only-export-components -- Provider and hook belong together */

import { createContext, use, useCallback, useEffect, useState } from 'react';
import { insertEventLog } from '../api/eventLogApi';
import { isReadLocked } from '../axios-config/authSession';

const EventLogContext = createContext(null);

const sendEvents = async (events) => {
  // A guest on an unknown device may not send anything before the device is unlocked; the events are dropped.
  if (events.length > 0 && !isReadLocked()) {
      try {
          await insertEventLog(events);
      } catch (error) {
          console.error("Fehler beim Senden von Events:", error);
      }
  }
};

const MAX_EVENT_QUEUE_SIZE = 3;

export function EventLogProvider({ children }) {
  const [events, setEvents] = useState([]);

  // Funktion zum Hinzufügen eines Events
  const logEvent = useCallback(event => {
    setTimeout(() => setEvents(prev => [...prev, event]), 0)
  }, [])

  useEffect(() => {
    if (events.length >= MAX_EVENT_QUEUE_SIZE) {
      sendEvents(events);
      queueMicrotask(() => setEvents([]));
    }
  }, [events]);

  return (
    <EventLogContext value={{ logEvent }}>
      {children}
    </EventLogContext>
  );
}

// Custom Hook, um EventLog-Kontext zu verwenden
export function useEventLog() {
  const context = use(EventLogContext);
  if (!context) {
    throw new Error('useEventLog must be used within an EventLogProvider');
  }
  return context;
}
